let items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");
console.log(items);
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

jQuery(document).ready(function($) {

  // Close all menus by default
  $(".sidebar-submenu").hide();
  $(".sidebar-parent .plusminus").text("+");

  // Find the active parent based on Shopify Liquid logic
  var activeParent = $(".sidebar-parent.active");

  if (activeParent.length > 0) {
    // Open the correct parent based on the active collection
    activeParent.find(".sidebar-submenu").show();
    activeParent.find(".plusminus").text("-");
  } else {
    // If no active parent, open the first one
    var firstParent = $(".sidebar-parent").first();
    firstParent.addClass("active");
    firstParent.find(".sidebar-submenu").show();
    firstParent.find(".plusminus").text("-");
  }

  // Toggle click
  $(".sidebar-toggle").on("click", function() {
    var parent = $(this).closest(".sidebar-parent");
    var submenu = parent.find(".sidebar-submenu");
    var icon = $(this).find(".plusminus");

    submenu.slideToggle(200);
    parent.toggleClass("active");

    icon.text(icon.text() === "+" ? "-" : "+");
  });

});

//blog page btn script 

document.addEventListener("DOMContentLoaded", function() {
  const btn = document.getElementById('show-all-btn');
  if (!btn) return;

  btn.addEventListener('click', function() {
    const hiddenBlogs = document.querySelectorAll('.extra-blog');
    hiddenBlogs.forEach(item => item.classList.remove('d-none'));

    this.style.display = 'none';
  });
});


// Table of content
document.addEventListener("DOMContentLoaded", function () {
  const tocList = document.getElementById("toc-list");
  if (!tocList) return;

  const contentWrapper = document.querySelector(".blog-content");
  if (!contentWrapper) return;

  // Select headings ONLY inside .blog-content
  const headings = contentWrapper.querySelectorAll("h2, h3, h4, h5, h6");

  headings.forEach((heading, index) => {
    // Assign unique ID if missing
    let id = heading.id;
    if (!id) {
      id = "heading-" + index;
      heading.id = id;
    }

    const li = document.createElement("li");

    // Add class based on hierarchy for styling
    li.classList.add("toc-" + heading.tagName.toLowerCase());

    const a = document.createElement("a");
    a.href = "#" + id;
    a.textContent = heading.textContent.trim();

    li.appendChild(a);
    tocList.appendChild(li);
  });
});



